// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memberId: __t.string().primaryKey().name("member_id"),
  restaurantId: __t.u64().name("restaurant_id"),
  role: __t.string(),
  homeFloor: __t.u32().name("home_floor"),
  homeX: __t.f32().name("home_x"),
  homeZ: __t.f32().name("home_z"),
  state: __t.string(),
  stateClockMs: __t.i64().name("state_clock_ms"),
  ticketId: __t.option(__t.u64()).name("ticket_id"),
  x: __t.f32(),
  z: __t.f32(),
  floor: __t.u32(),
  targetX: __t.f32().name("target_x"),
  targetZ: __t.f32().name("target_z"),
  targetFloor: __t.u32().name("target_floor"),
  assignedStoveUid: __t.string().name("assigned_stove_uid"),
  lastStoveUid: __t.string().name("last_stove_uid"),
  washTargetUid: __t.string().name("wash_target_uid"),
  washDirtyId: __t.i64().name("wash_dirty_id"),
  washPhase: __t.string().name("wash_phase"),
  takeOrderGuestId: __t.option(__t.u64()).name("take_order_guest_id"),
  spawnedAt: __t.timestamp().name("spawned_at"),
  deliveryPhase: __t.option(__t.string()).name("delivery_phase"),
  errandPhase: __t.option(__t.string()).name("errand_phase"),
  errandTripListCsv: __t.option(__t.string()).name("errand_trip_list_csv"),
  errandOffscreenUntilMicros: __t.i64().name("errand_offscreen_until_micros"),
  cleanSeatUid: __t.option(__t.string()).name("clean_seat_uid"),
  faceY: __t.f32().name("face_y"),
  onStair: __t.bool().name("on_stair"),
});
